import styled from '@emotion/styled';
import { tokens, Select } from '@hotjar/hotsauce';

export const S = {
  Select: styled(Select)`
    display: inline-block;
    width: inherit;
    margin-bottom: ${tokens.spacer.x2};
  `,
  Header: styled.h3`
    font-weight: normal;
    margin-bottom: 12px;
    margin-top: 53px;
  `,
  Content: styled.div`
    margin-top: ${tokens.spacer.x3};
  `,
  Footer: styled.div`
    margin-top: ${tokens.spacer.x3};
    border-top: 1px solid ${tokens.color.neutral_200};
    padding: ${tokens.spacer.x2pt5} 0;
  `,
  Grid: styled.div<{ rows: number }>`
    display: grid;
    grid-template-columns: 320px 200px;
    ${(props) => `grid-template-rows: repeat(${props.rows}, 1fr)`};
    grid-column-gap: 15px;
    grid-row-gap: 10px;
  `,
  GridCellHeader: styled.div`
    font-weight: bold;
    margin-bottom: ${tokens.spacer.x1};
  `,
};
